/**
 * 前端本地缓存统一清理（唯一实现）
 * 背景：清理逻辑此前散写在 device store / user store / 404 / 401 / Navbar 多处，
 *       各清各的范围（有的只清 sessionStorage，有的只清 localStorage），
 *       页面卡死时既清不干净也说不清清了什么。
 * 口径：登录 token 存在 cookie（见 ./auth.js 的 HuYu-Admin-Token），
 *       所以「连登录态一起清」必须覆盖 cookie，只清 storage 是不彻底的。
 */

/** 清本次会话缓存：router 落地记录、projectChanged 等 */
export function clearSessionCache() {
  sessionStorage.clear();
}

/** 清本机持久缓存：projectId、loginId、moduleId、modules、routerModuleList 等 */
export function clearLocalCache() {
  localStorage.clear();
}

/** 清 document.cookie 全部条目（含登录 token） */
export function clearCookieCache() {
  document.cookie.split(";").forEach((item) => {
    const name = item.split("=")[0].trim();
    if (!name) return;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  });
}

/**
 * 全清（含登录态），清完必然要求重新登录。
 * 只用于「退出登录 / 重新登录 / 一键清理缓存」这类用户明确要求回到干净态的动作；
 * 页面内的项目、模块切换不要调它。
 */
export function clearAllClientCache() {
  clearSessionCache();
  clearLocalCache();
  clearCookieCache();
}
